import React, { useState, useEffect } from "react";
import { TopicItem } from "../common/TopicGrid";
import { colors, spacing } from "../theme";
import styled from "styled-components";
import { Props as TopicGridProps } from "../common/TopicGrid";
import { StyledBookmarkCounter } from "../Header/InteractionMenu";
import api from "../../lib/clientApi";

const Container = styled.div`
  background-color: ${colors.paleGrey};
  ${spacing("padding", 48)}
  display: flex;
  justify-content: space-between;
`;

const Counter = styled(StyledBookmarkCounter)`
  margin: 0;
  margin-left: 12px;
`;
const StyledTopicGrid = styled(TopicItem)`
  background-color: ${colors.paleGrey};
`;

type Props = {
  categoryId: string;
} & TopicGridProps;

export default function JobCategoryTile(props: Props) {
  const [count, setCount] = useState<number>(null);

  useEffect(() => {
    let isCanceled = false;

    const fetchCount = async () => {
      const { total } = await api.listJobOffers({
        category: { eq: props.categoryId },
        limit: 0
      });
      if (!isCanceled) setCount(total);
    };
    fetchCount();

    return () => {
      isCanceled = true;
    };
  }, [props.categoryId]);

  return (
    <Container>
      <StyledTopicGrid {...props} embeddedStyle />
      {!!count && <Counter>{count}</Counter>}
    </Container>
  );
}
